import { STATUS_LOADED } from 'app/common/status/actions';

function getInstances(state) {
  return state.games.whoisit.instances
    .filter(({ status }) => status === STATUS_LOADED)
    .map(({ entity }) => entity);
}

export default getInstances;
